import { getConfig } from '@/api/index'

const config = {
  state: {
    'sitename': 'xxx',
    'sitenameAbbr': '',
    'domain': 'jijuxjs.com',
    'isOpen': 1,
    'refuseTips': '3',
    'title': '寄居蟹发卡平台',
    'keyword': '寄居蟹发卡平台-网上购物,C2C,在线交易,交易市场,网上交易,交易市场,网上买,网上卖,购物网站,团购,网上贸易,安全购物,电子商务,放心买,供应,买卖信息,网店,一口价,拍卖,网上开店,网络购物,打折,',
    'description': '寄居蟹发卡平台 - 亚洲较大的网上交易平台，提供各类服饰、美容、家居、数码、话费/点卡充值… 数亿优质商品，同时提供担保交易(先收货后付款)等安全交易保障服务，并由商家提供退货承诺、破损补寄等消费者保障服务',
    'qq': '800180273',
    'tel': '1998xxxx123',
    'company': '上海企传数字科技有限公司',
    'address': 'xxx省xxx市xxx区xxx街道xxx号',
    'email': '800180273@qq.com',
    'icp': '鄂ICP备19055205号-1',
    'copyright': 'Copyright©2020 上海企传数字科技有限公司',
    'license': 'All Rights Reserved. 2022 XXX版权所有',
    'baiduTuisong': '',
    'baiduVerification': '',
    'indexTheme': '2022_default',
    'mobileIndexTheme': '2022_default',
    'merchantTheme': '2022_default',
    'mobileMerchantTheme': '2022_default',
    'isRegister': 1,
    'isSms': 1,
    'wechartName': '寄居蟹发卡',
    'wechartErweima': 'https://xxjishou.oss-cn-hangzhou.aliyuncs.com/config/imgSave/17be05aaf7244fbdbe1cdcda2a09f74c.jpg',
    'takecash': 10,
    'isApplyTakecash': 1,
    'takecashF': 8,
    'takecashT': 18,
    'fee': 1
  },

  mutations: {
    SET_CONFIG: (state, config) => {
      Object.keys(config).forEach(key => {
        state[key] = config[key]
      })
    }
  },

  actions: {
    // 设置配置
    setConfig ({ commit }) {
      return new Promise((resolve, reject) => {
        getConfig().then((res) => {
          commit('SET_CONFIG', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./src/store/modules/config.js